import Canvas from '../_internal/components/canvases/canvas';
import { componentFactory } from '../../../fc-core/src//lib';
export default function (a) {
  var b;
  componentFactory(a, Canvas, 'canvas', a.config.showVolumeChart ? 2 : 1), b = a.getChildren('canvas');

  for (var c = 0, d = b.length; c < d; c++) {
    b[c].configure();
  }
}